import React from "react";
import { Navigate } from "react-router-dom";
import { useWorkspace } from "./WorkspaceContext";

const SMBGuard = ({ children }) => {
  const { subscribeType } = useWorkspace();

  if (subscribeType && subscribeType != 4) {
    return <Navigate to="/pricing" replace />;
  }

  return children;
};

export default SMBGuard;
